import { useRef } from "react";
import { motion } from "framer-motion";
import { Chip } from "@scripts/react/components/Chip";

export const SidebarHeader = ({
    title,
    description,
    showImageCountChip,
    currentImageCount,
    totalImagesNeeded,
    showRound,
    currentRound,
    totalRounds,
    onHelpClick
}: {
    title: string;
    description?: string | React.ReactNode;
    showImageCountChip?: boolean;
    currentImageCount?: number;
    totalImagesNeeded?: number;
    showRound?: boolean;
    currentRound?: number;
    totalRounds?: number;
    onHelpClick?: (anchorElement: HTMLElement) => void;
}) => {
    const chipRef = useRef<HTMLDivElement>(null);

    const hasChips =
        (showImageCountChip &&
            currentImageCount !== undefined &&
            totalImagesNeeded !== undefined) ||
        (showRound && currentRound !== undefined && totalRounds !== undefined && totalRounds > 1);

    const handleHelpClick = () => {
        if (onHelpClick && chipRef.current) {
            onHelpClick(chipRef.current);
        }
    };

    return (
        <motion.div className="header">
            <div
                className={`flex ${showRound ? "flex-col-reverse" : "flex-row"} items-center justify-between`}
            >
                <h2>{title}</h2>
                {hasChips && (
                    <div className="flex items-center gap-2">
                        {showRound &&
                            currentRound !== undefined &&
                            totalRounds !== undefined &&
                            totalRounds > 1 && (
                                <span className="text-xs font-bold text-tertiary">
                                    ROUND {currentRound}/{totalRounds}
                                </span>
                            )}
                        {showImageCountChip &&
                            currentImageCount !== undefined &&
                            totalImagesNeeded !== undefined && (
                                <Chip
                                    ref={chipRef}
                                    color="gray"
                                    size="small"
                                    className="cursor-pointer text-xs"
                                    onClick={handleHelpClick}
                                >
                                    <i className="far fa-image" />
                                    {currentImageCount}/{totalImagesNeeded}
                                </Chip>
                            )}
                    </div>
                )}
            </div>
            {description && <div>{description}</div>}
        </motion.div>
    );
};
